/**
 * RationaleCell — inline rationale hint + click-to-edit affordance.
 *
 * Renders the existing rationale truncated, or a "+ Add rationale"
 * link when blank. Clicking either swaps to the RationaleEditor
 * (rendered by the parent UNR155Tree, which owns editingItemId state
 * so the kebab "Edit rationale" action can open the editor too).
 */
import React from 'react';
import styles from './UNR155Tree.module.css';

const HINT_MAX = 64;

const truncate = (text) =>
  text && text.length > HINT_MAX ? `${text.slice(0, HINT_MAX - 1)}…` : text;

const RationaleCell = ({ rationale, onEdit }) => {
  const hasRationale = rationale && rationale.trim().length > 0;
  return (
    <button
      type="button"
      className={hasRationale ? styles.rationaleHint : styles.rationaleAdd}
      onClick={(e) => {
        e.stopPropagation();
        onEdit();
      }}
      title={hasRationale ? rationale : 'Add rationale'}
    >
      {hasRationale ? (
        <>
          <span className={styles.rationaleIcon} aria-hidden="true">✎</span>
          {truncate(rationale)}
        </>
      ) : (
        <>
          <span className={styles.rationaleIcon} aria-hidden="true">+</span>
          Add rationale
        </>
      )}
    </button>
  );
};

export default RationaleCell;
